<template>
  <div class="stock-document-chain-links">
    <StockLinkedTransportOrdersTable
      v-if="shouldShowTransportOrders"
      :items="transportOrderItems"
      :title="$t('STOCK.COMMON.RELATED_TRANSPORT_ORDERS')"
      :empty-message="$t('STOCK.COMMON.NO_RELATED_TRANSPORT_ORDERS')"
    />

    <StockLinkedPurchaseOrdersTable
      v-if="shouldShowPurchaseOrders"
      :items="purchaseOrders"
      :title="$t('STOCK.COMMON.RELATED_PURCHASE_ORDERS')"
      :empty-message="$t('STOCK.COMMON.NO_RELATED_PURCHASE_ORDERS')"
    />

    <StockLinkedSalesOrdersTable
      v-if="shouldShowSalesOrders"
      :items="salesOrders"
      :title="$t('STOCK.COMMON.RELATED_SALES_ORDERS')"
      :empty-message="$t('STOCK.COMMON.NO_RELATED_SALES_ORDERS')"
    />

    <StockLinkedStockActionsTable
      v-if="shouldShowStockActions"
      :items="stockActions"
      :title="stockActionsTitle"
      :empty-message="resolvedStockActionsEmptyMessage"
      :show-transport-order-column="showTransportOrderColumn"
    />

    <StockLinkedInvoicesTable
      v-if="shouldShowInvoices"
      :items="invoices"
      :title="resolvedInvoicesTitle"
      :empty-message="resolvedInvoicesEmptyMessage"
    />
  </div>
</template>

<script>
import StockLinkedTransportOrdersTable from "@/views/partials/stock/StockLinkedTransportOrdersTable.vue";
import StockLinkedPurchaseOrdersTable from "@/views/partials/stock/StockLinkedPurchaseOrdersTable.vue";
import StockLinkedSalesOrdersTable from "@/views/partials/stock/StockLinkedSalesOrdersTable.vue";
import StockLinkedStockActionsTable from "@/views/partials/stock/StockLinkedStockActionsTable.vue";
import StockLinkedInvoicesTable from "@/views/partials/stock/StockLinkedInvoicesTable.vue";

export default {
  name: "StockDocumentChainLinks",
  components: {
    StockLinkedTransportOrdersTable,
    StockLinkedPurchaseOrdersTable,
    StockLinkedSalesOrdersTable,
    StockLinkedStockActionsTable,
    StockLinkedInvoicesTable,
  },
  props: {
    sourceTransportOrder: {
      type: Object,
      default: null,
    },
    showTransportOrders: {
      type: Boolean,
      default: false,
    },
    purchaseOrders: {
      type: Array,
      default: () => [],
    },
    showPurchaseOrders: {
      type: Boolean,
      default: false,
    },
    salesOrders: {
      type: Array,
      default: () => [],
    },
    showSalesOrders: {
      type: Boolean,
      default: false,
    },
    stockActions: {
      type: Array,
      default: () => [],
    },
    showStockActions: {
      type: Boolean,
      default: false,
    },
    stockActionsTitle: {
      type: String,
      default: "",
    },
    stockActionsEmptyMessage: {
      type: String,
      default: "",
    },
    showTransportOrderColumn: {
      type: Boolean,
      default: false,
    },
    invoices: {
      type: Array,
      default: () => [],
    },
    showInvoices: {
      type: Boolean,
      default: false,
    },
    invoicesTitle: {
      type: String,
      default: "",
    },
    invoicesEmptyMessage: {
      type: String,
      default: "",
    },
  },
  computed: {
    transportOrderItems() {
      if (this.sourceTransportOrder && this.sourceTransportOrder.id) {
        return [this.sourceTransportOrder];
      }
      return [];
    },
    shouldShowTransportOrders() {
      return this.showTransportOrders || !!this.sourceTransportOrder;
    },
    shouldShowPurchaseOrders() {
      return this.showPurchaseOrders || this.purchaseOrders.length > 0;
    },
    shouldShowSalesOrders() {
      return this.showSalesOrders || this.salesOrders.length > 0;
    },
    shouldShowStockActions() {
      return this.showStockActions || this.stockActions.length > 0;
    },
    shouldShowInvoices() {
      return this.showInvoices || this.invoices.length > 0;
    },
    resolvedStockActionsEmptyMessage() {
      if (this.stockActionsEmptyMessage) {
        return this.stockActionsEmptyMessage;
      }
      return this.$t("STOCK.COMMON.NO_RELATED_RECEIPTS");
    },
    resolvedInvoicesTitle() {
      return this.invoicesTitle || this.$t("STOCK.COMMON.RELATED_INVOICES");
    },
    resolvedInvoicesEmptyMessage() {
      return this.invoicesEmptyMessage || this.$t("STOCK.COMMON.NO_RELATED_INVOICES");
    },
  },
};
</script>
